import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Logo from "../../images/logo.png";
import Field from "../../../common/components/Field";
import { initialValues } from "./values";
import { loginFormValidationSchema } from "./validation";
import { Formik } from "formik";
import { push } from "../../../router/history";
import { Grid, Card, Button, CircularProgress } from "@material-ui/core";
import styles from "./styles";

const Form = ({ classes, onRequestSend, isLoading }) => {
  return (
    <Formik
      initialValues={initialValues()}
      validationSchema={loginFormValidationSchema}
    >
      {(formik) => (
        <div>
          <div className={classes.background} />
          <Grid container className={classes.root}>
            <Grid item>
              <Card className={classes.card}>
                <Grid container className={classes.center}>
                  <Grid item>
                    <img width="260" height="110" alt="logo" src={Logo} />
                  </Grid>
                  <Grid className={classes.spacing}>
                    <Field name="email" type="email" formik={formik} />
                    <Field name="password" type="password" formik={formik} />
                    <Grid item xs={12} className={classes.backgroundButton}>
                      <div>
                      <Button
                        disabled={isLoading}
                        onClick={() => onRequestSend(formik.values)}
                        className={classes.button}
                      >
                        {isLoading ? (
                          <CircularProgress
                            className={classes.progress}
                            size={25}
                          />
                        ) : (
                          "ACESSAR"
                        )}
                      </Button>
                      <Button onClick={()=> push('/forgot-password')}color="primary" className={classes.forgotPassword}>Esqueci minha senha </Button> 
                      </div>
                    </Grid>
                  </Grid>
                </Grid>    
              </Card>
            </Grid>
          </Grid>
        </div>
      )}
    </Formik>
  );
};

export default withStyles(styles)(Form);
